import Api from '../api';

const apiInstance = Api.getInstance();

export const getConfig = (social) => {
  return apiInstance.get(`/configs/social?platform=${social}`);
};
